type ToastType = 'success' | 'error' | 'info';

const TOAST_CONTAINER_ID = 'app-toast-container';

const ensureToastContainer = (): HTMLElement => {
  let container = document.getElementById(TOAST_CONTAINER_ID);
  if (!container) {
    container = document.createElement('div');
    container.id = TOAST_CONTAINER_ID;
    container.className = 'app-toast-container';
    document.body.appendChild(container);
  }
  return container;
};

export const showToast = (text: string, type: ToastType = 'info'): void => {
  if (!text) return;

  const container = ensureToastContainer();
  const toast = document.createElement('div');
  toast.className = `app-toast app-toast-${type}`;
  toast.textContent = text;
  container.appendChild(toast);

  requestAnimationFrame(() => {
    toast.classList.add('app-toast-visible');
  });

  window.setTimeout(() => {
    toast.classList.remove('app-toast-visible');
    window.setTimeout(() => {
      toast.remove();
      if (container.childElementCount === 0) {
        container.remove();
      }
    }, 180);
  }, 1600);
};
